import axios from 'axios';
import axiosRetry from 'axios-retry';
import { useMessageContext } from '../libraries/contexts';
import persistenceService from './persistence-service';

const { REACT_APP_API_URL, REACT_APP_USER_ROL, REACT_APP_SLACK_URL } = process.env;

export const SERVER_API = REACT_APP_API_URL;
export const USER_ROL = REACT_APP_USER_ROL;
export const SLACK_URL = REACT_APP_SLACK_URL;

const headers = {
  'Content-Type': 'application/json; charset=utf-8'
};

export const publicInstance = axios.create({
  baseURL: SERVER_API,
  timeout: 300000,
  crossdomain: true,
  headers
});

export const httpInstance = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

publicInstance.interceptors.response.use(
  response => response,
  error => {
    console.log(error.message);
    console.log(JSON.stringify(error));
    try {
      const [value, setValue] = useMessageContext();
      console.log(value);
      setValue(error);
    } catch (er) {}
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.toLowerCase().includes('token')
    ) {
      persistenceService.clearPersistentDataProps();
      window.location.reload();
    }
    throw error;
  }
);

publicInstance.interceptors.request.use(
  config => {
    const access_token = persistenceService.get('token');
    if (access_token !== null) {
      config.headers.Authorization = `${access_token}`;
    }
    if (!access_token && !config.url.includes('login')) {
      window.location.reload();
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axiosRetry(publicInstance, {
  retries: 3
});

export const JString = json => JSON.stringify(json);

const API_PUBLIC_SERVICE = {
  async get(id) {
    const res = await publicInstance.get(`${SERVER_API}${this.path}/${id}`);
    let { data } = res;
    return data;
  },
  async getAll() {
    const res = await publicInstance.get(`${SERVER_API}${this.path}/all`);
    let { data } = await res;
    let { results } = data;
    return results;
  },
  async put(id, json) {
    try {
      const res = await publicInstance.put(`${SERVER_API}${this.path}/${id}`, JString(json));
      let { data } = await res;
      return data;
    } catch (err) {
      const {
        response: { data }
      } = await err;

      throw data;
    }
  },
  async undo(id) {
    const res = await publicInstance.post(`${SERVER_API}${this.path}/undo/${id}`, JString({}));
    let { data } = res;
    return data;
  },
  async delete(id) {
    const res = await publicInstance.delete(`${SERVER_API}${this.path}/${id}`);
    let { data } = res;
    return data;
  },
  async getPaginated(order, orderBy, page, rowsPerPage, filterData) {
    const filtered = `?size=${rowsPerPage}&page=${page}&${filterData}&sort=${order}${orderBy}`;
    const res = await publicInstance.get(`${SERVER_API}${this.path}/${filtered}`);
    let { data } = await res;
    return data;
  },
  async post(json) {
    try {
      const res = await publicInstance.post(`${SERVER_API}${this.path}`, JString(json));
      let { data } = await res;
      return data;
    } catch (err) {
      const {
        response: { data }
      } = await err;

      throw data;
    }
  }
};

export default API_PUBLIC_SERVICE;
